import { Navigate } from 'react-router-dom'
import Loader from '../pages/Loader'

const VerifiedRoute = ({user, isLoading, children}) => {
    if (isLoading) return <Loader />
    if (!user) return <Navigate to="/" />
    if (!user.isAccountVerified) return <Navigate to="/verify-email" />
    return children
}

export default VerifiedRoute